/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import {
    object, shape, string, bool,
} from 'prop-types';
import ProductImageMagnifierUI from '../ProductImageMagnifierUI';

const ProductImageZoomingUI = ({
    classes, data, imagePath, personalizationFlag, isRenderSnipe,
}) =>  {
    const [isSnipeImageShow, setSnipeImageShow] = useState(false);

    const [enableZoom, setEnableZoom] = useState(false);

    const [isZoomed, setIsZoomed] = useState(false);

    const isDesktop = useMediaQuery('(min-width: 1025px)');

    const renderSnipeImageTablet = (value) => {
        if (enableZoom && value) {
            setSnipeImageShow(true);
        } else {
            setSnipeImageShow(false);
        }
    };

    const renderSnipeImageDesktop = (value) => {
        setSnipeImageShow(value);
    };

    return (
        isDesktop
            ? (
                <div
                    className={classes.responsiveWrapper}
                    onPointerEnter={() => renderSnipeImageDesktop(true)}
                    onPointerLeave={() => renderSnipeImageDesktop(false)}
                >
                    <ProductImageMagnifierUI
                        imagePath={imagePath}
                        data={data}
                        classes={classes}
                        isSnipeImageShow={!isSnipeImageShow && isRenderSnipe}
                        personalizationFlag={personalizationFlag}
                        renderSnipeImage={renderSnipeImageDesktop}
                    />
                    <div className={classes.zoomCopyDesktop}>Hover over image to zoom</div>
                </div>
            ) : (
                <>
                    <div
                        className={classes.responsiveWrapper}
                        onPointerDown={() => setEnableZoom(true)}
                        onPointerMove={() =>  setEnableZoom(false)}
                        onPointerUp={() => renderSnipeImageTablet(true)}
                    >
                        <ProductImageMagnifierUI
                            imagePath={imagePath}
                            data={data}
                            classes={classes}
                            isSnipeImageShow={!isSnipeImageShow && isRenderSnipe}
                            personalizationFlag={personalizationFlag}
                            renderSnipeImage={renderSnipeImageTablet}
                            setIsZoomed={setIsZoomed}
                            isZoomed={isZoomed}
                        />
                    </div>
                </>
            ));
};
ProductImageZoomingUI.propTypes = {
    classes: object.isRequired,
    imagePath: string,
    data: shape({
        partNumber: string,
        id: string,

        image: shape({
            path: string,
            snipe: string,
            snipeImagePath: string,
            altText: string,
        }),
    }),
    personalizationFlag: bool,
    isRenderSnipe: bool,
};

ProductImageZoomingUI.defaultProps = {
    imagePath: '',
    data: {},
    personalizationFlag: false,
    isRenderSnipe: false,
};

export default ProductImageZoomingUI;
